const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

// Rejection doesn't change the order in Priority — it stays in the list; the
// backend emails the note to the responsible manager(s) + the agent.
// Errors are rethrown so RejectOrderDialog can show them and stay open.
const useRejectOrder = (execute, setSnackbar) => async (ordname, note) => {
  await execute("POST", `${BASE_URL}/api/tradeDelay/orders/${encodeURIComponent(ordname)}/reject`, { note });
  setSnackbar({ open: true, message: `הודעת דחייה להזמנה ${ordname} נשלחה לסוכן ולמנהל`, severity: "success" });
};

export default useRejectOrder;
